export default __webpack_public_path__ + "static/media/icon-1.c40ebb6d.png";